import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import { moreWaysToBrowseHeader } from '../sharedMessages';

import styles from './SharedMobileMoreWaysToBrowse.scss';

const SharedMobileMoreWaysToBrowseComponent = ({ viewer, internalBuyLinks }) => {
    const isEnabled = get(viewer, 'isMoreWaysToBrowseEnabled');

    if (!internalBuyLinks || !internalBuyLinks.length || !isEnabled) {
        return null;
    }

    return (
        <div className={styles.wrapper} data-tn="shared-mobile-more-ways-to-browse">
            <h2 className={styles.header}>{moreWaysToBrowseHeader}</h2>
            <div className={styles.innerWrapper}>
                <div className={styles.itemContainer}>
                    {internalBuyLinks.map(({ anchorText, url }) => (
                        <a
                            key={url}
                            href={url}
                            className={styles.item}
                            data-tn="shared-mobile-more-ways-to-browse-item"
                        >
                            {anchorText}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

SharedMobileMoreWaysToBrowseComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    internalBuyLinks: PropTypes.arrayOf(
        PropTypes.shape({
            anchorText: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        })
    ),
};

export const SharedMobileMoreWaysToBrowse = createFragmentContainer(
    SharedMobileMoreWaysToBrowseComponent,
    {
        viewer: graphql`
            fragment SharedMobileMoreWaysToBrowse_viewer on Viewer {
                isMoreWaysToBrowseEnabled: isEnabledByLocale(featureName: "MORE_WAYS_TO_BROWSE")
            }
        `,
        internalBuyLinks: graphql`
            fragment SharedMobileMoreWaysToBrowse_internalBuyLinks on InternalBuyLinkType
                @relay(plural: true) {
                anchorText
                url
            }
        `,
    }
);
